import axios from "axios";
import { API_URL, API_KEY } from "../.env";

const API = axios.create({
  baseURL: `${API_URL}/api/v1`,
  headers: {
    Authentication: API_KEY
  }
});

export function getProducts() {
  return new Promise((resolve, reject) => {
    API.get(`products`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function searchProducts(query) {
  return new Promise((resolve, reject) => {
    API.get(`products/search?query=${query}`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function searchQuotes(query) {
  return new Promise((resolve, reject) => {
    API.get(`quotes/search?field=${query.field}&value=${query.value}`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function getContact(id) {
  return new Promise((resolve, reject) => {
    API.get(`contacts/${id}`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function createContact(data) {
  return new Promise((resolve, reject) => {
    API.post(`contacts`, data)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function updateContact(id, data) {
  return new Promise((resolve, reject) => {
    API.put(`contacts/${id}`, data)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function getQuote(id) {
  return new Promise((resolve, reject) => {
    API.get(`quotes/${id}`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function createQuote(data) {
  return new Promise((resolve, reject) => {
    API.post(`quotes`, data)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function updateQuote(id, data) {
  return new Promise((resolve, reject) => {
    API.put(`quotes/${id}`, data)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function saveQuoteToCRM(id) {
  return new Promise((resolve, reject) => {
    API.post(`quotes/${id}/crm`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function sendQuote(id, data) {
  return new Promise((resolve, reject) => {
    API.post(`quotes/send/${id}`, data)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function fetchTestMethods() {
  return new Promise((resolve, reject) => {
    API.get(`test-methods`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function fetchTestMethodComponents(testMethodId) {
  return new Promise((resolve, reject) => {
    API.get(`test-methods/${testMethodId}/components`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function addLineItem(data) {
  return new Promise((resolve, reject) => {
    API.post(`line-items`, data)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function updateLineItem(id, data) {
  return new Promise((resolve, reject) => {
    API.put(`line-items/${id}`, data)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function deleteLineItem(id) {
  return new Promise((resolve, reject) => {
    API.delete(`line-items/${id}`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function addItemGroup(data) {
  return new Promise((resolve, reject) => {
    API.post(`item-groups`, data)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function updateItemGroup(id, data) {
  return new Promise((resolve, reject) => {
    API.put(`item-groups/${id}`, data)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function deleteItemGroup(id) {
  return new Promise((resolve, reject) => {
    API.delete(`item-groups/${id}`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}

export function discountOptions() {
  return new Promise((resolve, reject) => {
    API.get(`discount-options`)
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error.response.data);
      });
  });
}
